const clientId = process.env.REACT_APP_INTUNE_CLIENT_ID;
export const MSAL_SCOPES = [
  `api://${clientId}/access_as_user`
];